module.exports = __webpack_public_path__ + "img/guide_pic.f2b88ab3.png";